import { Injectable } from '@angular/core';
import { CoursesColumns } from '../columns/courses.columns';
import { ColumnDefiner, ColumnDefinition, ColumnGroup } from '../columns/column-group.class';
import { DriverColumns } from '../columns/driver.columns';
import { ReportMeta } from './reports.service';
import { MentorColumns } from '../columns/mentor.columns';
import { LicenceColumns } from '../columns/licence.columns';
import { AlertsColumns } from '../columns/alerts.columns';
import { RoadRiskColumns } from '../columns/roadrisk.columns';

@Injectable({ providedIn: 'root' })
export class ColumnsService {
  private readonly columnGroups: ColumnGroup[];
  private processedColumns: { [key: string]: ColumnDefinition } = {};

  public constructor(
    courses: CoursesColumns,
    drivers: DriverColumns,
    mentor: MentorColumns,
    licences: LicenceColumns,
    alerts: AlertsColumns,
    roadRisk: RoadRiskColumns
  ) {
    this.columnGroups = [courses, drivers, mentor, licences, alerts, roadRisk];
  }

  public getColumnDefinition(columnName: string): ColumnDefinition | null {
    let columnDefinition = null;

    for (let columnGroup of this.columnGroups) {
      if ((columnDefinition = columnGroup.getColumnDefinition(columnName))) {
        break;
      }
    }

    return this.processColumnDefinition(columnName, columnDefinition);
  }

  public getColumnsWithEvents(): { [key: string]: ColumnDefinition } {
    const columnsWithEvents = {};

    for (let columnGroup of this.columnGroups) {
      Object.entries(columnGroup.getAllColumns()).filter((column) => {
        const columnName = column[0];
        const columnDefinition = this.processColumnDefinition(columnName, column[1]);

        if (columnDefinition.hasOwnProperty('events')) {
          columnsWithEvents[columnName] = columnDefinition;
        }
      });
    }

    return columnsWithEvents;
  }

  public getColumnsWithEventsForReport(metadata: ReportMeta['structure']): { [key: string]: ColumnDefinition } {
    const columns = {};
    const columnsWithEvents = this.getColumnsWithEvents();

    Object.entries(columnsWithEvents).filter((column) => {
      const [columnName, columDefinition] = column;

      if (metadata.hasOwnProperty(columnName)) {
        columns[columnName] = this.processColumnDefinition(columnName, columDefinition);
      }
    });

    return columns;
  }

  public processColumnDefinition(name: string, definition: ColumnDefiner): ColumnDefinition {
    if (this.processedColumns[name]) {
      return this.processedColumns[name];
    }

    const processedDefinition = typeof definition === 'function' ? definition() : definition;
    this.processedColumns[name] = processedDefinition;

    return processedDefinition;
  }
}
